import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { fleetUserSchema } from '../schemas/fleet-user.schema';

/**
 * Get a user, including fleet information, by id
 * @param externalId The external ID of the user
 * @returns Paged Collection of Users
 */
export function getUsersFleetInfoId(this: unknown, externalId?: string) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).usersFleetInfoUrl}/${encodeURIComponent(externalId ?? '')}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
        }
      )
    )
  ).pipe(selectData(z.object({ data: z.array(fleetUserSchema) })));
}
